export enum ChainId {
  MAINNET = 16718,
  DEVNET = 30746,
  TESTNET = 22040,
}

export const SUPPORTED_CHAINS = [ChainId.MAINNET, ChainId.DEVNET, ChainId.TESTNET] as const
export type SupportedChainsType = (typeof SUPPORTED_CHAINS)[number]

export enum NativeCurrencyName {
  AMBER = 'AMB',
}
